<template>
  <v-container>
    <v-row wrap align-center>
      <v-col cols=12>
        <div class="text-center">
          <h1 class="headline font-weight-medium">
            {{ $vuetify.lang.t(`$vuetify.rusavic.title`) }}
          </h1>
        </div>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="8" offset-md="2" cols="12">
        <v-card tile>
          <v-card-text class="subtitle-1 black--text" v-html="$vuetify.lang.t(`$vuetify.rusavic.text`)">
          </v-card-text>
          <vue-plyr>
            <video playsinline controls>
              <source :src="davisInterspeechUrl" type="video/mp4">
            </video>
          </vue-plyr>
          <vue-plyr class="my-10">
            <video playsinline controls>
              <source :src="icmiUrl" type="video/mp4">
            </video>
          </vue-plyr>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="videos.length > 0">
      <v-tabs v-model="tab" center-active grow>
        <!--<v-tab v-for="entry in videos" :key="entry.type">{{ $vuetify.lang.t(`$vuetify.rusavic.tabs.${entry.type}`) }}</v-tab>-->
        <v-tab v-for="(entry, index) in videos" :key="entry.type">{{ $vuetify.lang.t(`$vuetify.rusavic.tabs.driver`, index + 1) }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="entry in videos"
          :key="`video-${entry.type}`">
          <v-row justify="space-around" align="center" class="px-5">
            <v-col cols="12" md="3" v-for="item in entry.videos" :key="item">
              <v-card flat>
                <v-lazy :options="{threshold: .5}">
                  <vue-plyr>
                    <video playsinline controls>
                      <source :src="item" type="video/mp4">
                    </video>
                  </vue-plyr>
                </v-lazy>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-row>
  </v-container>
</template>

<script>
import VuePlyr from 'vue-plyr'
import backend from '@/backend'

// const rusavic_video_names = [
//   'alexander_f_1.mp4',
//   'alexander_f_2.mp4',
//   'alexander_l_5.mp4',
//   'alexander_l_6.mp4',
//   'alexey_l_5.mp4',
//   'alexey_l_9.mp4',
//   'alexey_r_1.mp4',
//   'alexey_r_4.mp4',
//   'alexey_r_5.mp4',
//   'denis_f_1.mp4',
//   'denis_f_2.mp4',
//   'denis_l_13.mp4',
//   'denis_l_5.mp4',
//   'denis_l_6.mp4',
//   'denis_l_8.mp4',
//   'denis_r_29.mp4',
//   'denis_r_33.mp4'
// ]

export default {
  name: 'Сorpus',
  components: {
    VuePlyr
  },
  data: () => ({
    videos: [],
    sliders: {},
    tab: null
    // images: [
    //   require('@/assets/corpus/01.jpg'),
    //   require('@/assets/corpus/03.jpg'),
    //   require('@/assets/corpus/04.jpg'),
    //   require('@/assets/corpus/02.jpg')
    // ],
    // rusavic_video_names: [
    //   'alexander_f_1.mp4',
    //   'alexander_f_2.mp4',
    //   'alexander_l_5.mp4',
    //   'alexander_l_6.mp4',
    //   'alexey_l_5.mp4',
    //   'alexey_l_9.mp4',
    //   'alexey_r_1.mp4',
    //   'alexey_r_4.mp4',
    //   'alexey_r_5.mp4',
    //   'denis_f_1.mp4',
    //   'denis_f_2.mp4',
    //   'denis_l_13.mp4',
    //   'denis_l_5.mp4',
    //   'denis_l_6.mp4',
    //   'denis_l_8.mp4',
    //   'denis_r_29.mp4',
    //   'denis_r_33.mp4'
    // ],
    // videos: rusavic_video_names.map(item => `https://mobiledrivesafely.com//video/rusavic_examples/${item}`)
  }),
  methods: {
    async getVideoList () {
      try {
        this.videos = (await backend.getRusavicVideoList()).data
        for (const entry of this.videos) {
          entry.videos = entry.videos.map(item => `https://mobiledrivesafely.com/video/rusavic_simple/${encodeURIComponent(entry.directory)}/${item}`)
        }

        this.sliders = this.videos.reduce((acc, elem) => {
          acc[elem.type] = null
          return acc
        }, {})
      } catch (e) {
        console.error(e)
      }
    }
  },
  computed: {
    davisInterspeechUrl () {
      return 'https://mobiledrivesafely.com/video/DAVIS_INTERSPEECH_2022_v4.mp4'
    },
    icmiUrl () {
      return 'https://mobiledrivesafely.com/video/ICMI.mp4'
    }
  },
  async beforeRouteUpdate () {
    await this.getVideoList()
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      await vm.getVideoList()
    })
  }
}
</script>

<style scoped>

</style>
